import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import useShipInfosSelector from "_redux/hooks/useShipInfosSelector";
import { Typography, Box } from "@mui/material";
import { tss } from "tss-react/mui";
import { StyledDivider } from "components/StyledUI";

const useStyles = tss.create(({ theme }) => ({
  root: {
    border: `2px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    margin: theme.spacing(1, 0),
  },
  fullWidthDivider: {
    marginLeft: `-${theme.spacing(2)}`,
    marginRight: `-${theme.spacing(2)}`,
  },
}));

const MarketplaceShippingAddress: FC = () => {
  const { t } = useTranslation();
  const shippingInfos = useShipInfosSelector();
  const { classes } = useStyles();

  if (!shippingInfos) return null;

  const {
    firstname,
    lastname,
    address1,
    address2,
    address3,
    zipcode,
    city,
    email,
  } = shippingInfos;

  const fullName = [firstname, lastname].filter(Boolean).join(" ");
  const addressLines = [address1, address2, address3].filter(Boolean);
  const cityLine = [zipcode, city].filter(Boolean).join(" ");
  const emails = Array.from(
    new Set(
      email
        ?.split(",")
        .map((e) => e.trim())
        .filter(Boolean)
    )
  );

  return (
    <Box className={classes.root} mb={0}>
      <Typography variant="h3" mb={1}>
        {t("cart.shippingInformations")}
      </Typography>

      <StyledDivider light className={classes.fullWidthDivider} />

      {fullName && <Typography variant="body1">{fullName}</Typography>}

      {addressLines.map((line) => (
        <Typography key={line} variant="body1">
          {line}
        </Typography>
      ))}

      {cityLine && (
        <Typography variant="body1" mb={emails.length ? 1 : 0}>
          {cityLine}
        </Typography>
      )}

      {emails.map((mail) => (
        <Typography key={`email-${mail}`} variant="body1">
          {mail}
        </Typography>
      ))}
    </Box>
  );
};

export default React.memo(MarketplaceShippingAddress);
